import BModal from './modal';
import BVModalPlugin from './helpers/bv-modal';
import VBModal from '../../directives/modal/modal';
import { installFactory } from '../../utils/plugins';
var components = {
  BModal: BModal
};
var directives = {
  VBModal: VBModal
};
var plugins = {
  // $bvModal injection
  BVModalPlugin: BVModalPlugin
};
export { BModal };
export default {
  install: installFactory({
    components: components,
    directives: directives,
    plugins: plugins
  })
};